import { useContext } from "react";
import { AuthContext } from "../Auth/Context";
import { Navigate } from "react-router-dom";

export const PublicRoute = ({ children }) => {
  const { logged } = useContext(AuthContext);
  const lastPath = sessionStorage.getItem('lastPath') || '/option-dashboard';

  return (!logged)
    ? children
    : <Navigate to={lastPath} />
}
